import { WorkContext } from "../work/context";
import { AlbelliContext } from "../albelli/context";
import { AuthContext } from "../auth/context";

// getCareSafeCustomerId prioritizes the ownerId in a work or the canonicalId in an
// Albelli document over the customerId coming from the auth context. This is done
// because when a CARE agent is browsing the site, the customerId in the auth context
// will be the one from the CARE agent. But we want to continue serving recommendations
// for the actual customer.
export function getCareSafeCustomerId(
  workContext: WorkContext,
  albelliContext: AlbelliContext,
  authContext: AuthContext,
): string {
  return (
    workContext.work?.ownerId ||
    albelliContext.albelliDocument?.canonicalId ||
    authContext.customerId
  );
}
